const tabButton = document.querySelectorAll( '.tab-buttons .tab-title' );
const tabSelect = document.querySelectorAll( '.tab-select select' );

tabButton.forEach( ( tab ) => {
	tab.addEventListener( 'click', ( element ) => {
		const section = element.target.closest( 'section' );
		const tabIndex = element.target.dataset.tab;
		const tabContent = section.querySelector( '.tab-content[data-tab="' + tabIndex + '"]' );

		section.querySelectorAll('.tab-title').forEach( ( allTabs ) => { allTabs.classList.remove( 'active' ); } );
		section.querySelectorAll('.tab-content').forEach( ( allContent ) => { allContent.classList.remove( 'active' ); } );
		section.querySelector('.tab-select select').value = tabIndex;
		element.target.classList.add( 'active' );
		tabContent.classList.add( 'active' );
	} );
} );

tabSelect.forEach( ( select ) => {
	select.addEventListener( 'change', ( element ) => {
		const section = element.target.closest( 'section' );
		const tabIndex = element.target.value;
		const tabContent = section.querySelector( '.tab-content[data-tab="' + tabIndex + '"]' );

		section.querySelectorAll('.tab-title').forEach( ( allTabs ) => { allTabs.classList.remove( 'active' ); } );
		section.querySelectorAll('.tab-content').forEach( ( allContent ) => { allContent.classList.remove( 'active' ); } );
		section.querySelector('.tab-title[data-tab="' + tabIndex + '"').classList.add( 'active' );
		tabContent.classList.add( 'active' );
	} );
} );
